import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export default function Promocodes() {
  const [codes, setCodes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ code: '', discount: 100, days: 30, max_uses: 100 });

  useEffect(() => { fetchCodes(); }, []);

  const fetchCodes = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('promo_codes')
      .select('*')
      .order('created_at', { ascending: false });
    if (data) setCodes(data);
    setLoading(false);
  };

  const createCode = async () => {
    if (!form.code) { alert('Введите код'); return; }
    await supabase.from('promo_codes').insert({
      code: form.code.toUpperCase(),
      discount_percent: form.discount,
      free_days: form.days,
      max_uses: form.max_uses,
      used_count: 0,
      is_active: true,
    });
    setShowCreate(false);
    setForm({ code: '', discount: 100, days: 30, max_uses: 100 });
    fetchCodes();
  };

  const toggleCode = async (id: number, is_active: boolean) => {
    await supabase.from('promo_codes').update({ is_active: !is_active }).eq('id', id);
    fetchCodes();
  };

  const deleteCode = async (id: number) => {
    if (!window.confirm('Удалить промокод?')) return;
    await supabase.from('promo_codes').delete().eq('id', id);
    fetchCodes();
  };

  const generateCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = 'KITCHERY';
    for (let i = 0; i < 4; i++) code += chars[Math.floor(Math.random() * chars.length)];
    setForm({ ...form, code });
  };

  const formatDate = (d: string) => d ? new Date(d).toLocaleDateString('ru-RU') : '—';

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={s.title}>🎟️ Промокоды</h1>
        <button style={s.btn} onClick={() => setShowCreate(!showCreate)}>
          {showCreate ? 'Отмена' : '+ Создать промокод'}
        </button>
      </div>

      {showCreate && (
        <div style={s.card}>
          <h3 style={{ marginBottom: 16 }}>Новый промокод</h3>
          <div style={s.row}>
            <div style={s.field}>
              <label style={s.label}>Код *</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  style={s.input}
                  placeholder="KITCHERY2024"
                  value={form.code}
                  onChange={e => setForm({ ...form, code: e.target.value.toUpperCase() })}
                />
                <button style={s.btnSecondary} onClick={generateCode}>🎲 Генерировать</button>
              </div>
            </div>
            <div style={s.field}>
              <label style={s.label}>Скидка %</label>
              <input style={s.input} type="number" min={1} max={100} value={form.discount} onChange={e => setForm({ ...form, discount: parseInt(e.target.value) })} />
            </div>
          </div>
          <div style={s.row}>
            <div style={s.field}>
              <label style={s.label}>Дней бесплатно</label>
              <input style={s.input} type="number" min={1} value={form.days} onChange={e => setForm({ ...form, days: parseInt(e.target.value) })} />
            </div>
            <div style={s.field}>
              <label style={s.label}>Макс. использований</label>
              <input style={s.input} type="number" min={1} value={form.max_uses} onChange={e => setForm({ ...form, max_uses: parseInt(e.target.value) })} />
            </div>
          </div>
          <button style={s.btn} onClick={createCode}>💾 Создать</button>
        </div>
      )}

      {loading ? <p>Загрузка...</p> : codes.length === 0 ? (
        <div style={s.empty}>Промокодов нет</div>
      ) : (
        <table style={s.table}>
          <thead>
            <tr style={s.thead}>
              <th style={s.th}>Код</th>
              <th style={s.th}>Скидка</th>
              <th style={s.th}>Дней</th>
              <th style={s.th}>Использований</th>
              <th style={s.th}>Статус</th>
              <th style={s.th}>Создан</th>
              <th style={s.th}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {codes.map(c => (
              <tr key={c.id} style={s.tr}>
                <td style={s.td}><strong>{c.code}</strong></td>
                <td style={s.td}>{c.discount_percent}%</td>
                <td style={s.td}>{c.free_days} дней</td>
                <td style={s.td}>{c.used_count || 0} / {c.max_uses}</td>
                <td style={s.td}>
                  <span style={{ ...s.badge, backgroundColor: c.is_active ? '#d5f5e3' : '#f5f5f5', color: c.is_active ? '#2ECC71' : '#aaa' }}>
                    {c.is_active ? '✅ Активен' : '⏸ Отключён'}
                  </span>
                </td>
                <td style={s.td}>{formatDate(c.created_at)}</td>
                <td style={s.td}>
                  <button style={{ ...s.btnSmall, backgroundColor: c.is_active ? '#f39c12' : '#2ECC71' }} onClick={() => toggleCode(c.id, c.is_active)}>
                    {c.is_active ? 'Отключить' : 'Включить'}
                  </button>
                  <button style={{ ...s.btnSmall, backgroundColor: '#e74c3c' }} onClick={() => deleteCode(c.id)}>Удалить</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  title: { fontSize: 24, fontWeight: 700, color: '#222', margin: 0 },
  card: { backgroundColor: '#fff', borderRadius: 12, padding: 24, marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #eee' },
  row: { display: 'flex', gap: 16, marginBottom: 12 },
  field: { flex: 1, display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 13, fontWeight: 600, color: '#555' },
  input: { padding: '10px 14px', borderRadius: 8, border: '1px solid #eee', fontSize: 14, outline: 'none' },
  btn: { backgroundColor: '#2ECC71', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnSecondary: { backgroundColor: '#f5f5f5', color: '#555', border: '1px solid #eee', borderRadius: 8, padding: '10px 14px', fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' },
  empty: { textAlign: 'center', color: '#aaa', padding: 40, backgroundColor: '#fff', borderRadius: 12 },
  table: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  thead: { backgroundColor: '#f9f9f9' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: 13, color: '#888', fontWeight: 600 },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '12px 16px', fontSize: 14, color: '#222' },
  badge: { padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 500 },
  btnSmall: { padding: '6px 12px', backgroundColor: '#2ECC71', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer', marginRight: 6 },
};